import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { PencilIcon } from "@heroicons/react/20/solid";
import { shallow } from "zustand/shallow";
import useTabStore from "../stores/useTabStore";
import { Button } from "../ui-components/button-with-loading";

const PREDEFINED_TAB_IDS = ["default", "BrokerView"];

const MobileTabDropdown = () => {
  const { tabs, switchTab, activeTabId, addTab, renameTab } = useTabStore(
    (state) => ({
      tabs: state.tabs,
      switchTab: state.switchTab,
      activeTabId: state.activeTabId,
      addTab: state.addTab,
      renameTab: state.renameTab,
    }),
    shallow
  );

  const handleRenameTab = (e, tab) => {
    e.stopPropagation();
    const newTitle = prompt("Rename tab", tab.title);
    if (newTitle?.trim()) {
      renameTab(tab.id, newTitle.trim());
    }
  };

  const activeTab = tabs.find((tab) => tab.id === activeTabId) || tabs[0];

  const handleAddTab = () => {
    const title = prompt("Enter new tab title");
    if (title) {
      addTab(title);
    }
  };

  if (!activeTab) {
    return (
      <Button
        variant="secondary"
        onClick={handleAddTab}
        className="mx-auto !bg-gray-200 dark:!bg-gray-500 my-2"
        size="xs"
      >
        Add Tab +
      </Button>
    );
  }

  return (
    <Popover className="relative">
      <PopoverButton as={Button} variant="secondary" size="xs">
        <span className="capitalize">{activeTab.title}</span>
        <ChevronDownIcon aria-hidden="true" className="h-4 w-4" />
        <div className="border-t border-gray-300"></div>
      </PopoverButton>

      <PopoverPanel className="absolute z-10 mt-2 w-full min-w-[180px] bg-white dark:bg-gray-700 shadow-md border border-gray-200 dark:border-gray-600 rounded-lg ">
        <div className="py-1 min-w-full">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className="flex items-center justify-between px-1 py-2  w-full border-b last:border-none border-gray-200 dark:border-gray-500"
            >
              <Button
                variant="secondary"
                onClick={() => {
                  switchTab(tab.id);
                }}
                className="text-left text-xs text-gray-900 dark:text-gray-200 bg-transparent mx-auto flex-1 capitalize"
              >
                {tab.title}
              </Button>
              {!PREDEFINED_TAB_IDS.includes(tab.id) && (
                <button
                  onClick={(e) => handleRenameTab(e, tab)}
                  className="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                  aria-label={`Rename ${tab.title} tab`}
                >
                  <PencilIcon className="h-3.5 w-3.5" />
                </button>
              )}
            </div>
          ))}
          <Button
            variant="secondary"
            onClick={handleAddTab}
            className="mx-auto !bg-gray-200 dark:!bg-gray-500 my-2"
            size="xs"
          >
            Add Tab +
          </Button>
        </div>
      </PopoverPanel>
    </Popover>
  );
};

export default MobileTabDropdown;
